import { useQuery } from '@tanstack/react-query';
import { getSharedListSortEmails } from '../../../api/ListSort/getSharedListSortEmails';

export function useGetSharedListSortEmails() {
  const getQuery = useQuery({
    queryKey: [ 'get-shared-list-sort-emails' ],
    queryFn: () => getSharedListSortEmails()
  });

  if (getQuery.isError) {
    console.error('There was an error in useGetSharedListSortEmails ', getQuery);
  }

  return {
    data: getQuery.data?.data || null,
    error: getQuery.error || null,
    isLoading: getQuery.isLoading,
  };
}
